import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CalendarLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("rect", { width: 18, height: 15, x: 3, y: 6, stroke: "currentColor", rx: 2 }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 11h18M9 16h6M8 3v4M16 3v4" })] }) });
}
const CalendarLight = forwardRef(_CalendarLight);
export { CalendarLight };
